import { Box, Button, IconButton, Typography } from '@mui/material';
import React, { FC, MouseEvent } from 'react';
import logo from 'assets/images/logo-icon.svg';
import { useRightSideMenu } from 'app/hooks/right-side-menu';
import { useStyles } from './GuestSidebarHeader.styles';
import MenuIcon from '@mui/icons-material/Menu';

interface GuestSidebarHeaderProps {
  onMenuClick: (event: MouseEvent<HTMLElement>) => void;
}

export const GuestSidebarHeader: FC<GuestSidebarHeaderProps> = ({ onMenuClick }) => {
  const { classes } = useStyles();
  const { onLoginHandler } = useRightSideMenu();

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>
        <img src={logo} alt="icon" />
        <Typography className={classes.title}>Guest</Typography>
      </Box>

      <Box className={classes.controls}>
        <Button variant="contained" className={classes.button} onClick={onLoginHandler}>
          Log In
        </Button>
        <IconButton onClick={onMenuClick} aria-label="menu">
          <MenuIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
